module.exports = "/images/side-files-active.svg?925ea43dc0c431f104eed759bf9e55fe";